// extracted by mini-css-extract-plugin
export default {"three-section-button":"FeaturedProducts_three-section-button__gF6DD","sale-button":"FeaturedProducts_sale-button__iZC8L"};